import React from 'react';
import { RoomAvailabilityType } from '../../../types.ts';
import { styled } from 'styled-components';

const StyledTD = styled.td<{ isAvailable: boolean }>`
  color: black !important;
  text-align: center !important;
  border: 2px solid grey !important;
  cursor: pointer !important;
  background: ${({ isAvailable }) => (isAvailable ? '#88F684' : '#ff0000')} !important;
`;

interface RoomAvailabilityProps {
  availability: RoomAvailabilityType;
}

const RoomAvailability: React.FC<RoomAvailabilityProps> = ({ availability }) => (
  <StyledTD isAvailable={availability.IsAvailable}>{availability.AvailableCount}</StyledTD>
);

export default RoomAvailability;
